/**
 * OQ-1 placeholder: FA guid scoping + which `environment.apiEndpoints` slot BrightNav uses.
 * Live Http impl (follow-up story) reads this; mock ignores it.
 * One-line swap when OQ-1 resolves.
 */
export const FINANCIAL_SNAPSHOT_API_CONFIG = {
  /** Key into `environment.apiEndpoints`. */
  apiName: 'brightnav-api' as const,
  /** Path prefix for FS routes (no leading/trailing slash issues handled by caller). */
  pathPrefix: '/financialsnapshot',
  /**
   * How the selected client guid is scoped on GET/PATCH.
   * `'path'` → `/financialsnapshot/{guid}`; `'query'` / `'header'` reserved for OQ-1.
   */
  guidScope: 'path' as 'path' | 'query' | 'header',
  /** When true, use MockFinancialSnapshotApiService (default until DEP-1 + OQ-1). */
  useMock: true,
} as const;

export type FinancialSnapshotApiConfig = typeof FINANCIAL_SNAPSHOT_API_CONFIG;
